var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"chart-content",attrs:{"id":_vm.chartID}})])])}
var staticRenderFns = []

export { render, staticRenderFns }